<template>
    <div class="templete_box">
        <div class="templete">
            <div class="search_box clearfix">
                <div class="search_time search_inputBox">
                    <el-date-picker v-model="start_time" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="退货时间"></el-date-picker>
                    ~
                    <el-date-picker v-model="end_time" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="退货时间"></el-date-picker>
                </div>
                <select-down-customer ref="selectdowncustomer" class="searchCustomer" @changeselect="res=>{this.customer_id = res;}"></select-down-customer>
                <el-input class="search_input search_inputBox" v-model="params.sn" placeholder="退货单号"></el-input>
                <el-select class="search_select search_inputBox" v-model="params.brand_id" multiple collapse-tags placeholder="品牌" @visible-change="getSelectList('brand')">
                    <el-option v-for="list in selectMap.brand" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-model="params.breed_id" multiple collapse-tags placeholder="品名" @visible-change="getSelectList('breed')">
                    <el-option v-for="list in selectMap.breed" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-input class="search_input search_inputBox" v-model="params.bale_no" placeholder="包号"></el-input>
                <el-select class="search_select search_inputBox" v-model="params.warehouse_id" placeholder="仓库" multiple collapse-tags @visible-change="getSelectList('warehouse')">
                    <el-option v-for="(list,index) in selectMap.warehouse" :key="index" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox search_inputBox_long" v-model="params.salesman_id" clearable multiple collapse-tags placeholder="销售人" @visible-change="getSalemanList">
                    <el-option v-for="list in saleManList" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <!-- <el-select class="search_select search_inputBox" v-model="params.status" placeholder="订单状态">
                    <el-option :value="999" :label="'全部状态'"></el-option>
                    <el-option :value="3" :label="'未入库'"></el-option>
                    <el-option :value="4" :label="'已入库'"></el-option>
                </el-select> -->
                <div class="searchBtnList clearfix">
                    <div class="reset fcolor" @click="reset">重置</div>
                    <el-button  class="publicBtn" @click="getList(true)">查询</el-button>
                </div>
            </div>
            <!-- <div class="btnList clearfix">
                <el-button class="funcPublicBtn funcPublicBtnChecked" @click="enterType=2;enter();">确认入库</el-button>
                <el-button class="funcPublicBtn" @click="enterType=3;enter();">检尺入库</el-button>
            </div> -->
            <div class="tableBox">
                <tabletem :isLoading="tableLoading" :tablecol="tableCol" :tabledata="list" @getRow="getRow" @rowClick="rowClick"></tabletem>
            </div>
            <div class="pageBox">
                <pagination ref="pagination" :lastpages.sync="last_page" :currentpages.sync="params.page" :all.sync="total" :pagesizes.sync="params.per_page" @getPage="getPage"></pagination>
            </div>
        </div>
        <el-dialog v-dialog-drag :visible.sync="dialogVisible" class="eldialog eldialogLine" :modal="false" title="入库确认" custom-class="full_dialog">
            <div class="dialogSearchBox">
                <el-form class="clearfix dialogFormB">
                    <el-form-item  label="选择仓库：" prop="container_no">
                        <el-select v-model="warehouse_id" @visible-change="getSelectList('warehouse')">
                            <el-option v-for="(list,index) in selectMap.warehouse" :key="index" :value="list.id" :label="list.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item v-if="enterType==3" label="退货方数：" prop="container_no">
                        <el-input v-model="return_cube"></el-input>
                    </el-form-item>
                    <el-form-item v-if="enterType==3" label="退货片数：" prop="container_no">
                        <el-input v-model="return_pieces"></el-input>
                    </el-form-item>
                    <el-form-item v-if="enterType==3" label="检尺码单立方：" prop="container_no">
                        <el-input v-model="cube" @input="changeA"></el-input>
                    </el-form-item>
                    <el-form-item v-if="enterType==3" label="检尺立方：" prop="container_no">
                        <el-input v-model="check_cube"></el-input>
                    </el-form-item>
                    <el-form-item v-if="enterType==3" label="检尺片数：" prop="container_no">
                        <el-input v-model="pieces" @input="changeB"></el-input>
                    </el-form-item>
                    <el-form-item v-if="enterType==3" label="销售立方：" prop="container_no">
                        <el-input v-model="sales_cube"></el-input>
                    </el-form-item>
                    <el-form-item  label="入库时间：" prop="container_no">
                        <el-date-picker v-model="inbound_time" value-format="yyyy-MM-dd" type="date" placeholder="入库时间"></el-date-picker>
                        <!-- {{new Date().getTime()/1000 | dateFormat_}} -->
                    </el-form-item>
                    <div class="elFormBoxBtnListCol">
                        <el-button class="funcPublicBtn funcPublicBtnChecked" @click="enterFunc">确认入库</el-button>
                    </div>
                </el-form>
            </div>
        </el-dialog>
        <!-- 宽度列表START -->
        <el-dialog v-dialog-drag :visible.sync="dialogVisibleWidth" class="eldialog totalWidthDialog" width="820px" :modal="false" custom-class="full_dialog">
            <total-widthnew :edit="false" :list="widthList" @cancelWidth="()=>{this.dialogVisibleWidth = false;}"></total-widthnew>
        </el-dialog>
        <!-- 宽度列表END -->
    </div>
</template>
<script>
    import tabletem from '../../../components/table.vue'
    import pagination from '../../../components/pagination.vue'
    import selectDownCustomer from '../../../components/selectDownCustomer.vue'
    export default {
        data(){
            return{
                tableLoading:false,
                start_time:"",
                end_time:"",
                params:{
                    start_time:"",
                    end_time:"",
                    customer_id:"",
                    sn:"",
                    brand_id:"",
                    breed_id:"",
                    bale_no:"",
                    warehouse_id:"",
                    salesman_id : "",
                    // status:999,
                    page:1,
                    per_page:50
                },
                customer_id:"",
                dialogVisible:false,
                dialogVisibleWidth:false,
                widthList:[],
                last_page:1,
                total:0,
                selectRow:[],
                selectionDetailRow:[],
                warehouseList:[],
                warehouse_id:"",
                pieces:"",
                cube:"",
                return_pieces:"",
                return_cube:"",
                check_cube:"",
                sales_cube:"",
                inbound_time:new Date(),

                enterType:2,//2确认入库 3检尺入库
                customerList:[],
                breedList:[],
                brandList:[],
                selectMap:{
                    breed:[],
                    brand:[],
                    customer:[],
                    warehouse:[]
                },
                list:[],
                tableCol:[
                    {colName:"退货单号",colKey:"order_return_sn",colWidth:190,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"状态",colKey:"status_text",colWidth:84,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"退货时间",colKey:"return_time",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"销售人",colKey:"salesman_name",colWidth:84,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"捆包号",colKey:"bale_no",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"客户名称",colKey:"customer_name",colWidth:168,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"品牌",colKey:"brand",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"品名",colKey:"breed",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"等级",colKey:"grade",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"厚度",colKey:"original_thickness",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"长度",colKey:"original_length",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"总宽度",colKey:"original_width_total",colWidth:80,isSetWidth:true,isCanClick:true,isShow:true,isColor:true,isHideShowClickImg:true,isHideCanClickColor:true},
                    {colName:"退货片数",colKey:"return_pieces",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"退货方数",colKey:"return_cube",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"仓库",colKey:"warehouse",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"退货原因",colKey:"remark",colWidth:150,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"制单人",colKey:"creator_name",colWidth:84,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"审核人",colKey:"auditor_name",colWidth:84,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"入库确认人",colKey:"stock_creator_name",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                ],
                totalObj:{},
                selectIds:[],
                fields:"",

                saleManList : [],
            }
        },
        created(){
            this.getList()
        },
        methods:{
            changeA(val){
                this.check_cube=val;
            },
            changeB(val){
                this.sales_cube=val;
            },
            getSelectList(target){
                this.$getSelectList(target).then(res=>{
                    this.selectMap[res.target]=res.list;
                })
            },
            enter(){
                if(this.selectRow.length<=0){
                    this.tip("请选择数据","warning")
                    return;
                }else{
                    if(this.enterType==3){
                        if(this.selectRow.length>1){
                            this.tip("检尺入库只能选择一条数据","warning")
                            return;
                        }else{
                            this.return_pieces=this.selectRow[0].return_pieces;
                            this.return_cube=this.selectRow[0].return_cube;
                        }
                    }
                    this.selectIds=[];
                    this.selectRow.forEach(item=>{
                        this.selectIds.push(item.id)
                    })
                    this.dialogVisible=true;
                    //this.enterFunc()
                }
            },
            enterFunc(){
                this.$confirm('是否确认入库?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let obj = new Object();
                    obj.id=this.selectIds;
                    obj.warehouse_id=this.warehouse_id;
                    obj.cube=this.cube;
                    obj.pieces=this.pieces;
                    obj.check_cube=this.check_cube;
                    obj.sales_cube=this.sales_cube;
                    obj.inbound_time=this.formatTimeZero(new Date());
                    let url = this.enterType==2?"/erp/return.stock.confirm":"/erp/return.stock.confirm.check"
                    this.postFunc(url,obj,()=>{
                        this.tip('入库成功','success');
                        this.dialogVisible=false;
                        this.getList()
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(()=>{});
            },
            reset(){
                this.start_time="";
                this.end_time="";
                this.params=this.resetSearch(this.params)
                this.customer_id = "";
                this.params.status=999;
                this.$refs['selectdowncustomer'].clearData()
                this.getList();
            },
            getList(flag){
                if(flag){
                    this.params.page = 1;
                }
                this.params.start_time=this.formatTimeZero(this.start_time);
                this.params.end_time=this.formatTimeZero(this.end_time);
                if(this.customer_id!=''){
                    let arr = [this.customer_id];
                    this.params.customer_id = arr;
                }
                this.tableLoading = true;
                this.$axios.post("/erp/return.stock.logs",this.params).then((response) => {
                    if(response.data.code == 0){
                        this.last_page = parseInt(response.data.data.last_page);
                        this.total = parseInt(response.data.data.total);
                        this.$refs.pagination.flag = true;
                        this.tableLoading = false;
                        this.list = response.data.data.data;
                        this.list.forEach((item) => {
                            item.return_time = window.moment( Number(item.return_time) * 1000 ).format("YYYY-MM-DD");
                            // item.original_width_total = parseInt(item.original_width_total)
                        })
                    }
                })
                // this.postFunc("/erp/return.stock.logs",this.params,res=>{
                //     this.last_page=parseInt(res.data.data.last_page);
                //     this.params.page=parseInt(res.data.data.current_page);
                //     this.total=parseInt(res.data.data.total);
                //     this.list=res.data.data.data;
                //     this.list.forEach((item,index)=>{
                //         if(item.return_time!=0){
                //             this.list[index].return_time = this.formatTime(item.return_time+"000")
                //         }
                //         this.list[index].original_width_total = parseInt(this.list[index].original_width_total)
                //         this.list[index].return_cube = this.keepLimit(this.list[index].return_cube)
                //     })
                //     this.fields=","+(res.data.data.fields.join(",")).toString()+",";
                //     this.tableCol.forEach(item=>{
                //         if(this.fields.indexOf(","+item.colKey+",")!=-1){
                //             item.isShow=true;
                //         }else{
                //             item.isShow=false;
                //         }
                //         if(item.colKey=="status_text"){
                //             if(this.fields.indexOf(",status,")!=-1){
                //                 item.isShow=true;
                //             }
                //         }
                //     })
                // },error=>{
                //     this.tip(error.data.message,"warning")
                // })
            },

            getPage(obj){
                this.params.page=obj.currentpage;
				this.params.per_page=obj.pagesize;
            },
            rowClick(obj){
                if(obj.name=="original_width_total"){
                    this.list.forEach(item=>{
                        if(item.id==obj.id){
                            this.widthList = item.width;
                            this.dialogVisibleWidth = true;
                        }
                    })
                }
                // this.postFunc("/erp/return.detail",{id:obj.id},res=>{
                //     this.pl(res)
                //     this.form_params=res.data.data;
                //     this.form_params.details.forEach((item,index) => {
                //         this.form_params.details[index].return_cube=this.keepLimit(this.form_params.details[index].return_cube)
                //         this.form_params.details[index].sales_cube=this.keepLimit(this.form_params.details[index].sales_cube)
                //         this.form_params.details[index].out_cube=this.keepLimit(this.form_params.details[index].out_cube)
                //         this.form_params.details[index].sales_price=this.keepPrice(this.form_params.details[index].sales_price)
                //         this.form_params.details[index].totalPrice=this.keepPrice(Number(this.form_params.details[index].sales_price)*Number(this.form_params.details[index].sales_cube))
                //     });
                //     this.dialogVisible=true;
                // },error=>{
                //     this.tip(error.data.message,"warning")
                // })
            },
            selectionDetailChange(row){
                this.selectionDetailRow=row;
            },
            getRow(row){
                this.selectRow=row;
            },
            toggleSelection(row) {
                this.$refs.outBoundDetailTable.toggleRowSelection(row);
            },
            // 获取销售员
            getSalemanList(visible){
                if(visible){
                    this.$getSalemanList('',1).then(res=>{
                        this.saleManList = res.data.data;
                    })
                }
            }
        },
        components:{
            tabletem,
            pagination,
            selectDownCustomer
        },
        watch:{
            "params.page":function(){
                this.getList();
            },
            "params.per_page":function(){
                this.getList();
            },
            "dialogVisible":function(val){
                if(!val){
                    this.warehouse_id="";
                    this.pieces="";
                    this.cube="";
                    this.sales_cube="";
                    this.check_cube="";
                }
            }
        }
    }
</script>
<style scoped lang="scss">
    // dialog START
    .bottom_flex{ display: flex; padding-right: 12px; padding-bottom: 8px; }
    .editPayBox{
        .editPay{width:50%;float: left;height:100px;box-sizing:border-box;padding:10px;}
        .editName{font-size: 12px;color:#777;}
        .editPay:nth-child(2n){border-left:1px solid #ccc;}
    }
    .editPersonBox{
        .editPerson{width:33%;float: left;font-size: 12px;color:#777;box-sizing: border-box;padding:5px 0;}
    }
    .editBtnList{padding-top:10px;
        .editTax{float: left;}
        .editTaxname{float: left;font-size: 12px;color:#777;line-height: 25px;margin-right:5px;}
        .editTaxinput{float: left;width:100px;}
        .editBtn{float: right;}
    }
    // dialog END
</style>
